/**
 * Shared referral-share helpers.
 *
 * Extracted from `components/landing/WaitlistSuccess.jsx` in Batch BC so
 * the new `components/dashboard/ReferFriendsWidget.jsx` can reuse the
 * exact same channel list, share-link builder, and intent URLs without
 * duplicating the logic. Both surfaces import from this module — any
 * future channel addition lands in one place.
 *
 * Context-specific copy lives next to the channel list. Each surface
 * imports its own message constant so share-conversion stays optimized
 * per acquisition moment ("skip ahead in the queue" reads very
 * differently from "invite friends to RunIdea.ai"). Future surfaces add
 * their own constant in this file.
 */
import { Twitter, Linkedin, MessageCircle, Mail as MailIcon } from "lucide-react";

export const REWARD_TARGET = 3;

export const SHARE_MESSAGE_WAITLIST =
  "I just joined the RunIdea.ai waitlist — AI-powered real estate underwriting. " +
  "Use my link to skip ahead:";

export const SHARE_MESSAGE_DASHBOARD =
  "I'm using RunIdea.ai — AI-powered real estate investment analysis. " +
  "Try it with my invite link:";

export const SHARE_CHANNELS = [
  { id: "twitter", label: "Share on X", Icon: Twitter },
  { id: "linkedin", label: "Share on LinkedIn", Icon: Linkedin },
  { id: "whatsapp", label: "Share on WhatsApp", Icon: MessageCircle },
  { id: "email", label: "Share by email", Icon: MailIcon },
];

export function buildShareLink(code) {
  if (!code) return "";
  if (typeof window === "undefined") return "";
  return `${window.location.origin}/?ref=${encodeURIComponent(code)}`;
}

export function shareIntentUrl(channel, link, { message } = {}) {
  const msg = message || SHARE_MESSAGE_DASHBOARD;
  const text = `${msg} ${link}`;
  switch (channel) {
    case "twitter":
      return `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}`;
    case "linkedin":
      return `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(link)}`;
    case "whatsapp":
      return `https://wa.me/?text=${encodeURIComponent(text)}`;
    case "email":
      return (
        "mailto:?subject=" +
        encodeURIComponent("Check out RunIdea.ai") +
        "&body=" +
        encodeURIComponent(text)
      );
    default:
      return link;
  }
}

// Channel id → human label for the share button caption.
export function channelLabel(id) {
  switch (id) {
    case "twitter": return "X";
    case "linkedin": return "LinkedIn";
    case "whatsapp": return "WhatsApp";
    case "email": return "Email";
    default: return id;
  }
}
